module.exports = __webpack_public_path__ + "img/cf94013.jpg";